<template>
<div class="bigpage">

<div class="in_body_topics_title" >{{singup_title}}</div>
<div class="in_body">
	<div class="in_body_null" v-if="topics_status == 'error_url'">未找到此活动相关信息</div>
	<div class="in_body_inc" v-if="topics_status == 1 && finishPost == false" >{{singup_inc}}</div>
	<div class="in_body_date" v-if="topics_status == 1 && finishPost == false" >活动日期：{{start_date.slice(0,10) }} 至 {{end_date.slice(0,10)}}</div>

	<div class="in_body_files" v-if="topics_status == 1 && topicsFiles.length != 0 && finishPost == false" >
		<div class="in_body_files_row" v-for="items in topicsFiles" @click="handleShowDoc(items.file_name)">{{ items.show_name }}</div>
		<div class="clear"></div>
	</div>


	<div v-if="topics_status == 0">
		<div class="in_body_panel" style="height: 1500px; color: #1c4981; padding-top: 80px; text-align: center;">活动已结束</div>
	</div>

	<div v-if="topics_status == 1">
		<div class="in_body_topbar" v-if="is_self_edit == 'y'" >
			<!-- <div class="btn_get_edit" v-if="finishPost == false" @click="handleShowVerify">修改资料</div> -->
			<div class="btn_get_edit_row" v-if="finishPost == false" @click="handleShowVerify">修改已提交资料</div>
			<div class="clear"></div>
		</div>
		<div v-for="(item, index) in peopleData" v-if="finishPost == false">
			<div class="in_body_panel">
				<i class="el-icon-delete btn_del"  @click="handleDelUser(index)"  v-if="index != 0" ></i>
				<el-row :gutter="20" class="pcpk">
					<el-col :span="24"><span class="red_dot">*</span>公司名称：
						<el-input type="text" size="medium" v-model="item.company_name" maxlength="200"  placeholder="请输入内容"></el-input>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="pcpk">
					<el-col :span="10"><span class="red_dot">*</span>
						
						<span v-if="topics_singup_type == 'pp'">姓名：</span>
						<span v-if="topics_singup_type == 'px'">参训人姓名：</span>
						<el-input type="text" size="medium" v-model="item.name" maxlength="50"  placeholder="请输入内容"></el-input>
					</el-col>
					<el-col :span="8"><span class="red_dot">*</span>性别：
						<el-select size="medium"  v-model="item.sex" placeholder="请选择">
							<el-option
							v-for="itema in sex_list"
							:key="itema.value"
							:label="itema.label"
							:value="itema.value">
							</el-option>
						</el-select>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="pcpk">
					<el-col :span="14"><span class="red_dot">*</span>部门：
						<el-input type="text" size="medium" v-model="item.dept" maxlength="80"  placeholder="请输入内容"></el-input>
					</el-col>
					<el-col :span="10"><span class="red_dot">*</span>职务：
						<el-input type="text" size="medium" v-model="item.duty" maxlength="80"  placeholder="请输入内容"></el-input>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="pcpk">
					<el-col :span="24"><span class="red_dot">*</span>手机号：
						<el-input type="text" size="medium" v-model="item.phone" maxlength="11"  placeholder="请输入内容"></el-input>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="pcpk">
					<el-col :span="24">
						<span class="red_dot"  v-if="topics_singup_type == 'px'">*</span>邮箱：
						<el-input type="text" size="medium" v-model="item.email" maxlength="100"  placeholder="请输入内容"></el-input>
					</el-col>
				</el-row>

				<div v-if="switch_room == 'y'">
					<el-row :gutter="20" class="pcpk">
						<el-col :span="20"><span class="red_dot">*</span>需要住宿：
							<el-radio v-model="item.needroom" label="1">是</el-radio>
							<el-radio v-model="item.needroom" label="0">否</el-radio>
						</el-col>
					</el-row>
					<div v-if="item.needroom == '1'">
						<el-row :gutter="20" class="pcpk">
							<el-col :span="12"><span class="red_dot">*</span>选择房型：
								<el-select size="medium"  v-model="item.room_type" placeholder="请选择">
									<el-option
									v-for="items in room_list"
									:key="items.value"
									:label="items.label"
									:value="items.value">
									</el-option>
								</el-select>
							</el-col>
							<el-col :span="10" v-if="item.room_type == '标间'"><span class="red_dot">*</span>是否拼住：
								<el-radio v-model="item.spell_room" label="1">是</el-radio>
								<el-radio v-model="item.spell_room" label="0">否</el-radio>
							</el-col>
						</el-row>
						
						<el-row :gutter="20" class="pcpk" v-if="item.spell_room == 1">
							<el-col :span="22" :offset="1" class="spell_detail">
								<el-radio-group v-model="item.roommate_type">
									<div class="checked_row">
										<el-radio :label="1">填写同住人</el-radio>
										<el-row :gutter="20" style="margin-top: 15px;">
											<el-col :span="8">
												<div class="checked_row_label">同住人姓名：</div>
												<el-input type="text" size="small" v-model="item.roommate_name" maxlength="20" placeholder="请输入内容"></el-input>
											</el-col>
											<el-col :span="15">
												<div class="checked_row_label">同住人手机尾号（后四位）：</div>
												<el-input type="text" size="small" v-model="item.roommate_phone" maxlength="4" placeholder="请输入内容"></el-input>
											</el-col>
										</el-row>
									</div>

									<div class="checked_row">
										<el-radio :label="2">无，系统匹配同性别拼住人</el-radio>
										<div class="panel_end_change_room" v-if="item.roommate_type == 2">
											<div class="soq_sss">若<strong>报名截止前</strong>未能匹配到拼住人，是否更换为大床房：</div>
											<el-radio-group v-model="item.end_change_room">
												<el-radio :label="'y'" class="ixx_row">是，更换为大床房</el-radio>
												<el-radio :label="'n'" class="ixx_row">否，保持标间</el-radio>
											</el-radio-group>
										</div>
									</div>

									<div class="clear"></div>
								</el-radio-group>
							</el-col>
						</el-row>

						<el-row :gutter="20" class="pcpk">
							<el-col :span="12"><span class="red_dot">*</span>入住时间：
								<el-date-picker
									v-model="item.checkin"
									type="date"
									placeholder="选择日期" size="medium" style="width: 99%;" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
								</el-date-picker>
							</el-col>
							<el-col :span="12"><span class="red_dot">*</span>离店时间：
								<el-date-picker
									v-model="item.checkout"
									type="date"
									placeholder="选择日期" size="medium" style="width: 99%;" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
								</el-date-picker>
							</el-col>
						</el-row>

					</div>
				</div>

				<div class="date_tips_panel">{{date_tips}}</div>
			</div>
		</div>

		<div class="btnrow" v-if="finishPost == false">
			<div class="btnrow_adduser" @click="handleAddUser">添加人员</div>
			<div class="clear"></div>
		</div>

		<div style="margin-top: 40px;" class="in_body_panel" v-if="finishPost == false">
			<el-row :gutter="10" class="pcpk">
				<el-col :span="7"><span class="red_dot">*</span>联系人：
					<el-input type="text" size="medium" v-model="contactData.name" maxlength="50"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="11"><span class="red_dot">*</span>手机号：
					<el-input type="text" size="medium" v-model="contactData.phone" maxlength="11"  placeholder="请输入内容"></el-input>
				</el-col>
				<el-col :span="6"><el-button :disabled="btn_sendcode_disabled" type="primary" size="small" @click="hanldeSendCode" class="btn_sendcode" plain>{{btn_sendcode_label}}</el-button></el-col>
			</el-row>

			<el-row :gutter="10" class="pcpk">
				<el-col :span="11" :offset="7"><span class="red_dot">*</span>收到的验证码：
					<el-input type="text" size="medium" v-model="contactData.smscode" maxlength="6"  placeholder="请输入内容"></el-input>
				</el-col>
			</el-row>

			<div v-if="topics_singup_type == 'px'">

				<el-row :gutter="20" class="pcpk">
					<el-col :span="24"><span class="red_dot">*</span>接收发票邮箱：
						<el-input type="text" size="medium" v-model="contactData.email" maxlength="100"  placeholder="请输入内容"></el-input>
					</el-col>
				</el-row>

				<el-row :gutter="20" class="pcpk">
					<el-col :span="16"><span class="red_dot">*</span>发票抬头：
						<el-input type="text" size="medium" v-model="contactData.tax_title" maxlength="200"  placeholder="请输入内容"></el-input>
					</el-col>
					<el-col :span="8" class="fplx_row"><span class="red_dot">*</span>发票类型：
						<el-radio v-model="contactData.tax_type" label="z">专票</el-radio>
						<el-radio v-model="contactData.tax_type" label="p">普票</el-radio>
					</el-col>
				</el-row>

				<el-row :gutter="20" class="pcpk" >
					<el-col :span="24"><span class="red_dot">*</span>税号：
						<el-input type="text" size="medium" v-model="contactData.tax_no" maxlength="40"  placeholder="请输入内容"></el-input>
					</el-col>
				</el-row>

				<el-row :gutter="20" class="pcpk" >
					<el-col :span="14">银行账号：
						<el-input type="text" size="medium" v-model="contactData.tax_number" maxlength="80"  placeholder="请输入内容"></el-input>
					</el-col>
					<el-col :span="10">开户行：
						<el-input type="text" size="medium" v-model="contactData.tax_bank" maxlength="140"  placeholder="请输入内容"></el-input>
					</el-col>

				</el-row>

				<el-row :gutter="20" class="pcpk" >
					<el-col :span="14">地址：
						<el-input type="text" size="medium" v-model="contactData.tax_address" maxlength="220"  placeholder="请输入内容"></el-input>
					</el-col>
					<el-col :span="10">电话：
						<el-input type="text" size="medium" v-model="contactData.tax_tel" maxlength="15"  placeholder="请输入内容"></el-input>
					</el-col>
				</el-row>

				<el-row :gutter="20" class="pcpk" >
					<el-col :span="24">
						<el-checkbox v-model="contactData.need_tax_remark">发票需要特殊备注</el-checkbox>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="pcpk" v-if="contactData.need_tax_remark==true">
					<el-col :span="24">
						<el-input type="textarea" :rows="2" size="medium" v-model="contactData.tax_remark" maxlength="220" show-word-limit placeholder="请输入发票的特殊备注内容"></el-input>
					</el-col>
				</el-row>
		</div>


		</div>

		<div class="in_body_panel" v-if="finishPost == false">
			<el-row :gutter="20" class="pcpk">
				<el-col :span="24">备注：
					<el-input type="textarea" :rows="3" size="medium" v-model="remark" maxlength="220" show-word-limit placeholder="请输入内容"></el-input>
				</el-col>
			</el-row>
		</div>


		<div class="finish_page" v-if="finishPost == true">
			<div class="finish_page_title">信息填报成功！</div>
			<div class="finish_page_sub_title">您填报的内容：</div>
			<div v-for="items in peopleData" class="info_panel_people">
				<el-row :gutter="20" class="pcpk">
					<el-col :span="24">公司名称：<strong>{{items.company_name}}</strong></el-col>
				</el-row>
				<el-row :gutter="20" class="pcpk">
					<el-col :span="12" v-if="topics_singup_type == 'pp'">姓名：<strong>{{items.name}}</strong></el-col>
					<el-col :span="12" v-if="topics_singup_type == 'px'">参训人姓名：<strong>{{items.name}}</strong></el-col>
					<el-col :span="8">性别：<strong>{{items.sex}}</strong></el-col>
				</el-row>
				<el-row :gutter="20" class="pcpk">
					<el-col :span="12">部门：<strong>{{items.dept}}</strong></el-col>
					<el-col :span="8">职务：<strong>{{items.duty}}</strong></el-col>
				</el-row>
				<el-row :gutter="20" class="pcpk">
					<el-col :span="24">手机号：<strong>{{items.phone}}</strong></el-col>
				</el-row>
				<el-row :gutter="20" class="pcpk">
					<el-col :span="24">邮箱：<strong>{{items.email}}</strong></el-col>
				</el-row>

				<div v-if="switch_room == 'y'">
					<el-row :gutter="20" class="pcpk">
						<el-col :span="20">需要住宿：
							<strong v-if="items.needroom == '1'">是</strong>
							<strong v-if="items.needroom == '0'">否</strong>
						</el-col>
					</el-row>
					<div v-if="items.needroom == '1'">
						<el-row :gutter="20" class="pcpk">
							<el-col :span="14">房型：<strong>{{items.room_type}}</strong></el-col>
							<el-col :span="10" v-if="items.room_type == '标间'">
								是否拼住：
								<strong v-if="items.spell_room == '1'">是</strong>
								<strong v-if="items.spell_room == '0'">否</strong>
							</el-col>
						</el-row>

						<el-row :gutter="20" class="pcpk"  v-if="items.spell_room == '1'">
							<el-col :span="24"  v-if="items.roommate_type == '1'" >同住人姓名：<strong>{{items.roommate_name}}</strong> 同住人手机尾号（后四位）：<strong>{{items.roommate_phone}}</strong></el-col>
							<el-col :span="24"  v-if="items.roommate_type == '2'" >
								<strong>系统匹配同住人。</strong>若报名截止前未能匹配到拼住人，是否更换为大床房：
								<strong v-if="items.end_change_room == 'y'" >是，更换为大床房</strong>
								<strong v-if="items.end_change_room == 'n'">否，保持标间</strong>
							</el-col>
						</el-row>
						
						<el-row :gutter="20" class="pcpk">
							<el-col :span="12">入住时间：<strong>{{items.checkin}}</strong></el-col>
							<el-col :span="12">离店时间：<strong>{{items.checkout}}</strong></el-col>
						</el-row>
					</div>
				</div>
				
			</div>
			<div class="info_panel_contact">
				<el-row :gutter="20" class="pcpk">
					<el-col :span="10">联系人：<strong>{{contactData.name}}</strong></el-col>
					<el-col :span="14">手机号：<strong>{{contactData.phone}}</strong></el-col>
				</el-row>
				<div v-if="topics_singup_type == 'px'">
					<el-row :gutter="20" class="pcpk">
						<el-col :span="24">接收发票邮箱：<strong>{{contactData.email}}</strong></el-col>
					</el-row>
					<el-row :gutter="20" class="pcpk">
						<el-col :span="18">发票抬头：<strong>{{contactData.tax_no}}</strong></el-col>
						<el-col :span="6">发票类型：
							<strong v-if="contactData.tax_type == 'p'" >普票</strong>
							<strong v-if="contactData.tax_type == 'z'">专票</strong>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="pcpk">
						<el-col :span="24">税号：<strong>{{contactData.tax_title}}</strong></el-col>
					</el-row>

					<el-row :gutter="20" class="pcpk" v-if="contactData.tax_bank">
						<el-col :span="24">开户行：<strong>{{contactData.tax_bank}}</strong></el-col>
					</el-row>
					<el-row :gutter="20" class="pcpk" v-if="contactData.tax_number">
						<el-col :span="24">银行账号：<strong>{{contactData.tax_number}}</strong></el-col>
					</el-row>
					<el-row :gutter="20" class="pcpk" v-if="contactData.tax_address">
						<el-col :span="24">地址：<strong>{{contactData.tax_address}}</strong></el-col>
					</el-row>
					<el-row :gutter="20" class="pcpk" v-if="contactData.tax_tel">
						<el-col :span="24">电话：<strong>{{contactData.tax_tel}}</strong></el-col>
					</el-row>
					<el-row :gutter="20" class="pcpk" v-if="contactData.tax_remark">
						<el-col :span="24">发票特殊备注：<strong>{{contactData.tax_remark}}</strong></el-col>
					</el-row>
				</div>
			</div>
			<div class="info_panel_remark">
				<el-row :gutter="20" class="pcpk">
					<el-col :span="24">备注：<strong>{{remark}}	</strong></el-col>
				</el-row>
			</div>
			<div class="btn_edit_data" @click="handleEditSingup" >修改填报内容</div>
			<div class="clear"></div>
		</div>

		<div class="btn_save_all" v-if="finishPost == false" @click="handleSaveSingup">保存并提交</div>
	</div>
	
	<div class="page_bottom"></div>
	
</div>

<el-dialog width="98%" title="阅读文件" @close="handleClearIframe" :visible.sync="dialogDocViewVisible">
  <iframe class="iframe_cs" :src="iframeSrc" id="show_doc"></iframe>
</el-dialog>

<el-drawer
  title="修改您已提交的资料"
  :visible.sync="dialogShowVerifyVisible"
  direction="btt" size="50%">
 	<div class="panel_body_ss">
		<span>请输入您填写表单时的联系人手机号：</span>

		<el-row :gutter="10" class="pcpk">
			<el-col :span="15"><span class="red_dot">*</span>手机号：
				<el-input type="text" size="medium" v-model="editdata_phone" maxlength="11"  placeholder="请输入内容"></el-input>
			</el-col>
			<el-col :span="8"><el-button :disabled="btn_sendeditcode_disabled" type="primary" size="small" @click="hanldeSendEditCode" class="btn_sendcode" plain>{{btn_sendeditcode_label}}</el-button></el-col>
		</el-row>

		<el-row :gutter="10" class="pcpk">
			<el-col :span="10"><span class="red_dot">*</span>收到的验证码：
				<el-input type="text" size="medium" v-model="editdata_smscode" maxlength="6"  placeholder="请输入内容"></el-input>
			</el-col>
		</el-row>

		<el-row :gutter="10" class="pcpk">
			<el-col :span="10">
				<el-button type="primary" @click="handleGetEditData">验证</el-button>
			</el-col>
		</el-row>

	</div>
</el-drawer>


</div>
</template>

<script>

import * as SBD from '@/api/common'

export default {
    name: 'singup',
	data() {
		return {
			topics_singup_type:'',
			is_self_edit:'',
			dialogDocViewVisible:false,
			topicsFiles:[],
			switch_room:'',
			topics_status:1,
			btn_sendeditcode_label:'发送验证码',
			editdata_phone:'',
			editdata_smscode:'',
			btn_sendeditcode_disabled:false,
			dialogShowVerifyVisible:false,
			btn_sendcode_disabled:false,
			timer:'',
			timeLift:59,
			btn_sendcode_label:'发送验证码',
			start_date:'',
			end_date:'',
			roommate_type:1,
			roommate_name:'',
			roommate_phone:'',
			end_change_room:'',
			singup_title:'',
			singup_inc:'',
			date_tips:'',
			finishPost:false,
			edit_data_uuid:'-',
			peopleData:[{
				'company_name':'',
				'name':'',
				'sex':'',
				'dept':'',
				'duty':'',
				'phone':'',
				'email':'',
				'needroom':'',
				'room_type':'',
				'spell_room':'',
				'checkin':'',
				'checkout':'',
				'roommate_type':'',
				'roommate_name':'',
				'roommate_phone':'',
				'end_change_room':'',
			}],
			contactData:{
				'name':'',
				'phone':'',
				'email':'',
				'tax_no':'',
				'tax_title':'',
				'smscode':'',
				'tax_number':'',
				'tax_bank':'',
				'tax_address':'',
				'tax_tel':'',
				'tax_type':'',
				'need_tax_remark':'',
				'tax_remark':''
			},
			remark:'',
			pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now(); 
                }
			},
			topics_uuid:this.$route.query.uid,
			sex_list:[
				{value: '男',label: '男'},
				{value: '女',label: '女'},
			],
			room_list:[
				{value: '大床',label: '大床'},
				{value: '标间',label: '标间'},
			],
		}
	},  
	onload() {
		// this.$forceUpdate();
		
	},
	created() {
		if ( this.topics_uuid == 'pg2k22bk' ){
			this.room_list = [{value: '标间',label: '标间'}];
		}
		this.initData();
	},
	// mounted() {
	// 	window.addEventListener('beforeunload', this.handleBeforeUnload);
	// },
	// beforeDestroy() {
	// 	window.removeEventListener('beforeunload', this.handleBeforeUnload);
	// },
	methods: {
		handleClearIframe(){
			this.iframeSrc='';
		},
		handleShowDoc(filedata){
		
			console.log("filedata",filedata);
			let me = this;
			// me.dialogDocTitle=filedata;
			me.iframeSrc = '';

			var authorization_url = 'https://api.subudian.com/subudian/index/uploadQCcloud';
			var cos = new COS({
				getAuthorization: function (options, callback) {
					var url = authorization_url;
					var xhr = new XMLHttpRequest();
					xhr.open('GET', url, true);
					xhr.onload = function (e) {
						try {
							var data = JSON.parse(e.target.responseText);
							var credentials = data.credentials;
						} catch (e) {
						}
						if (!data || !credentials) {
						return console.error('credentials invalid:\n' + JSON.stringify(data, null, 2))
						};
						callback({
						TmpSecretId: credentials.tmpSecretId,
						TmpSecretKey: credentials.tmpSecretKey,
						SecurityToken: credentials.sessionToken,
						StartTime: data.startTime,
						ExpiredTime: data.expiredTime,
					});
					};
					xhr.send();
				}
			});

			let check_fileid = filedata.split(".");
			// if ( check_fileid[check_fileid.length - 1] == "" ){
			// 	filedata = filedata + ".mp4";
			// }
			// console.log("check_fileid",check_fileid);
			console.log("check_fileid",check_fileid);

			if ( check_fileid[check_fileid.length - 1] == "jpg" || check_fileid[check_fileid.length - 1] == "jpeg" || check_fileid[check_fileid.length - 1] == "png" || check_fileid[check_fileid.length - 1] == "mp4" || check_fileid[check_fileid.length - 1] == "" ){
				cos.getObjectUrl({
					Bucket:'wendao-1251754209', /* 填入您自己的存储桶，必须字段 */
					Region: 'ap-beijing', /* 存储桶所在地域，例如 ap-beijing，必须字段 */
					Key: 'subudian/' + filedata, /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），支持中文，必须字段 */
					Sign: true, /* 获取带签名的对象 URL */
				},
				function (err, data) {
					if (err) return console.log(err);
					/* url为对象访问 url */
					var url = data.Url;
					console.log(url)

					var viewUrl = url +
					(url.indexOf('?') > -1 ? '&' : '?') +
					'response-content-disposition=inline'; // 补充预览的参数

					me.iframeSrc = viewUrl;
					me.dialogDocViewVisible = true;
					console.log("viewUrl",viewUrl)
					//location.href=url
					//window.open(url)
					// $(".iframe_body").show()
					// $(".cover_all").show()
					// $("#show_doc").attr('src',url)
					/* 复制 downloadUrl 的值到浏览器打开会自动触发下载 */
					// var downloadUrl =
					// url +
					// (url.indexOf('?') > -1 ? '&' : '?') +
					// 'response-content-disposition=attachment'; // 补充强制下载的参数
					// console.log(downloadUrl)
				});
			}else if ( check_fileid[check_fileid.length - 1] == "doc" || check_fileid[check_fileid.length - 1] == "docx" || check_fileid[check_fileid.length - 1] == "pdf" || check_fileid[check_fileid.length - 1] == "xls" ){
				cos.getObjectUrl({
					Bucket:'wendao-1251754209', /* 填入您自己的存储桶，必须字段 */
					Region: 'ap-beijing', /* 存储桶所在地域，例如 ap-beijing，必须字段 */
					Key: 'subudian/' + filedata, /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），支持中文，必须字段 */
					Sign: true, /* 获取带签名的对象 URL */
					DataType: 'blob',
				}, function(err, data) {
					if (err) {
					console.log(err);
					} else {
					// 使用浏览器打开 url 即可预览
					var url = data.Url;

					// var viewUrl = url +
					// (url.indexOf('?') > -1 ? '&' : '?') +
					// 'response-content-disposition=inline'; // 补充预览的参数

					var downloadUrl =
					url +
					(url.indexOf('?') > -1 ? '&' : '?') +
					'response-content-disposition=attachment';

					window.open(downloadUrl)
					return
					me.iframeSrc = viewUrl;
					me.dialogDocViewVisible = true;
					console.log("viewUrl",viewUrl)
					// $(".iframe_body").show()
					// $(".cover_all").show()
					// $("#show_doc").attr('src',url)
					// window.open(url)
					// console.log(url);
					}
				});
			}else{
				cos.getObjectUrl({
					Bucket:'wendao-1251754209', /* 填入您自己的存储桶，必须字段 */
					Region: 'ap-beijing', /* 存储桶所在地域，例如 ap-beijing，必须字段 */
					Key: 'subudian/' + filedata, /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），支持中文，必须字段 */
					Sign: true, /* 获取带签名的对象 URL */
					DataType: 'blob',
				},
				function (err, data) {
					if (err) return console.log(err);
					/* url为对象访问 url */
					var url = data.Url;
					console.log(url)

					var viewUrl = url +
					(url.indexOf('?') > -1 ? '&' : '?') +
					'response-content-disposition=inline'; // 补充预览的参数

					me.iframeSrc = viewUrl;
					me.dialogDocViewVisible = true;

					console.log("viewUrl",viewUrl)
					//location.href=url
					//window.open(url)
					// $(".iframe_body").show()
					// $(".cover_all").show()
					// $("#show_doc").attr('src',url)
					/* 复制 downloadUrl 的值到浏览器打开会自动触发下载 */
					var downloadUrl =
					url +
					(url.indexOf('?') > -1 ? '&' : '?') +
					'response-content-disposition=attachment'; // 补充强制下载的参数
					console.log(downloadUrl)
					window.open(downloadUrl)
					return
				});
			}

			

		},
		handleSetRoomTypeData(e){
			console.log(e)
			let me = this;
			if ( e == '大床'){
				me.newrow_spell_room ='';
				me.newrow_roommate_name ='';
				me.newrow_roommate_phone ='';
				me.newrow_roommate_type ='';
				me.newrow_end_change_room ='';
			}
		},
		handleGetEditData(){
			if( !this.editdata_phone || this.editdata_phone.length != 11 ){
				this.$message({
					message: '请检查联系人手机号是否正确',
					type: 'warning'
				});
				return
			}
			if( !this.editdata_smscode || this.editdata_smscode.length != 6 ){
				this.$message({
					message: '请检查短信验证码是否正确',
					type: 'warning'
				});
				return
			}
			let me = this;
			let post={
				url_id:this.topics_uuid,
				u_type:'edit_sms',
				u_phone:this.editdata_phone,
				u_code:this.editdata_smscode
			}
			SBD.getUserEditData(post).then(res => {
				if ( res.status == 'no_data' ){
					me.$message({
						message: '没有您手机号的提交记录',
						type: 'warning'
					});
					return
				}

				if ( res.status == 'wrong_sms' ){
					me.$message({
						message: '短信验证码错误或者过期',
						type: 'warning'
					});
					return
				}

				me.edit_data_uuid = res.edit_data_uuid;
				me.remark = res.remark;
				me.contactData.name = res.contact.name;
				me.contactData.phone = res.contact.phone;
				me.contactData.email = res.contact.email;
				me.contactData.tax_no = res.contact.tax_no;
				me.contactData.tax_title = res.contact.tax_title;

				me.contactData.tax_number = res.contact.tax_number;
				me.contactData.tax_bank = res.contact.tax_bank;
				me.contactData.tax_address = res.contact.tax_address;
				me.contactData.tax_tel = res.contact.tax_tel;

				me.contactData.tax_type = res.contact.tax_type;
				me.contactData.need_tax_remark = res.contact.need_tax_remark;
				me.contactData.tax_remark = res.contact.tax_remark;

				
				me.peopleData = res.people;

				me.$message({
					message: '数据已取回，进入修改状态',
					type: 'success'
				});
				me.dialogShowVerifyVisible = false;
				
			})
		},
		handleClose(){
			this.btn_sendeditcode_label = '发送验证码';
			this.editdata_phone = '';
			this.editdata_smscode = '';
		},
		handleShowVerify(){
			this.btn_sendeditcode_label = '发送验证码';
			this.editdata_phone = '';
			this.editdata_smscode = '';
			this.dialogShowVerifyVisible = true
		},
		startCountdown() {
			if( this.timeLift == 0 ){
				this.timeLift = 59;
				this.btn_sendcode_label = "发送验证码";
				this.btn_sendcode_disabled = false;
				this.btn_sendeditcode_label = "发送验证码";
				this.btn_sendeditcode_disabled = false;
				clearInterval(this.timer);
			}else{
				this.timeLift --;
				this.btn_sendcode_label = this.timeLift;
				this.btn_sendeditcode_label = this.timeLift;
			}
		},
		hanldeSendEditCode(){
			if( !this.editdata_phone || this.editdata_phone.length != 11 ){
				this.$message({
					message: '请检查手机号是否正确',
					type: 'warning'
				});
				return
			}
			this.btn_sendeditcode_disabled = true;
			let me = this;
			let post={
				u_type:'edit_sms',
				u_phone:this.editdata_phone,
			}
			SBD.setSendSMSCode(post).then(res => {
				if ( res == 'timelimit' ){
					me.$message({
						message: '距离上次发送不足1分钟',
						type: 'warning'
					});
					me.btn_sendeditcode_disabled = false;
					return
				}
				me.$message({
					message: '已发送，请注意【斐车云】前缀验证码',
					type: 'success'
				});
				me.timer = setInterval(this.startCountdown, 1000);
			})
		},
		hanldeSendCode(){
			if( !this.contactData.phone || this.contactData.phone.length != 11 ){
				this.$message({
					message: '请检查联系人手机号是否正确',
					type: 'warning'
				});
				return
			}
			this.btn_sendcode_disabled = true;
			let me = this;
			let post={
				u_type:'new_sms',
				u_phone:this.contactData.phone,
			}
			SBD.setSendSMSCode(post).then(res => {
				if ( res == 'timelimit' ){
					me.$message({
						message: '距离上次发送不足1分钟',
						type: 'warning'
					});
					me.btn_sendcode_disabled = false;
					return
				}
				me.$message({
					message: '已发送，请注意【斐车云】前缀验证码',
					type: 'success'
				});
				me.timer = setInterval(this.startCountdown, 1000);
			})
		},
		handleEditSingup(){
			this.finishPost = false;
		},
		handleBeforeUnload(event) {
			const message = '确定要离开吗？';
			event.returnValue = message; // 兼容老版本浏览器
			return message; // 标准方法
		},
		handleDelUser(index){
			console.log(index)
			this.peopleData.splice(index,1);
		},
		handleAddUser(){
			this.peopleData.push({
				'company_name':this.peopleData[0].company_name,
				'name':'',
				'sex':'',
				'dept':'',
				'duty':'',
				'phone':'',
				'email':'',
				'needroom':'',
				'room_type':'',
				'spell_room':'',
				'checkin':'',
				'checkout':'',
				'roommate_type':'',
				'roommate_name':'',
				'roommate_phone':'',
				'end_change_room':'',
			});
		},
		handleSaveSingup(){

			console.log("this.peopleData",this.peopleData);
			
			let ready_data = true;
			for( let i=0; i<this.peopleData.length; i++ ){

				if( this.topics_singup_type == 'px' ){
					if ( !this.peopleData[i].company_name || !this.peopleData[i].sex || !this.peopleData[i].dept || !this.peopleData[i].duty || !this.peopleData[i].phone || !this.peopleData[i].email ){
						this.$message({
							message: '请填写红色星号项目',
							type: 'warning'
						});
						ready_data = false;
						return
					}
				}	

				if( this.topics_singup_type == 'pp' ){
					if ( !this.peopleData[i].company_name || !this.peopleData[i].sex || !this.peopleData[i].dept || !this.peopleData[i].duty || !this.peopleData[i].phone ){
						this.$message({
							message: '请填写红色星号项目',
							type: 'warning'
						});
						ready_data = false;
						return
					}
				}

				if( this.switch_room == 'y' ){
					
					if ( !this.peopleData[i].needroom ){
						this.$message({
							message: '请选择是否住宿',
							type: 'warning'
						});
						ready_data = false;
						return
					}

					if ( this.peopleData[i].needroom == '1' ){

						if ( !this.peopleData[i].room_type || !this.peopleData[i].checkin || !this.peopleData[i].checkout ){
							this.$message({
								message: '请把房型、入住离开日期都填一下',
								type: 'warning'
							});
							ready_data = false;
							return
						}
						
						if ( this.peopleData[i].checkin > this.peopleData[i].checkout ){
							this.$message({
								message: '签到日期晚于离店日期',
								type: 'warning'
							});
							ready_data = false;
							return
						}
						
						if ( this.peopleData[i].room_type=='标间' && !this.peopleData[i].spell_room ){
							this.$message({
								message: '标间请选择是否拼房',
								type: 'warning'
							});
							ready_data = false;
							return
						}

						if ( this.peopleData[i].spell_room == '1' && !this.peopleData[i].roommate_type ){
							this.$message({
								message: '请选择拼房方式',
								type: 'warning'
							});
							return
						}

						if ( this.peopleData[i].roommate_type == '1' && !this.peopleData[i].roommate_name ){
							this.$message({
								message: '请填写拼住人姓名',
								type: 'warning'
							});
							return
						}

						if ( this.peopleData[i].roommate_type == '1' && !this.peopleData[i].roommate_phone ){
							this.$message({
								message: '请填写拼住人手机号后四位',
								type: 'warning'
							});
							return
						}

						if ( this.peopleData[i].spell_room == '1' && this.peopleData[i].roommate_type == '2' ){
							if( !this.peopleData[i].end_change_room){
								this.$message({
									message: '请选择一下结束时是否换房',
									type: 'warning'
								});
								return
							}
						}


					}
		
				}
				
			}


			if( this.topics_singup_type == 'px' ){
				if ( !this.contactData.name || !this.contactData.phone || !this.contactData.email || !this.contactData.tax_no || !this.contactData.tax_title|| !this.contactData.tax_type){
					this.$message({
						message: '请填写联系人相关红色星号项目',
						type: 'warning'
					});
					ready_data = false;
					return
				}
			}

			if( this.topics_singup_type == 'pp' ){
				if ( !this.contactData.name || !this.contactData.phone ){
					this.$message({
						message: '请填写联系人相关红色星号项目',
						type: 'warning'
					});
					ready_data = false;
					return
				}
			}


			if( ready_data == false ){
				return
			}

			if( this.contactData.phone.length != 11 ){
				this.$message({
					message: '请检查联系人手机号是否正确',
					type: 'warning'
				});
				ready_data = false
				return
			}

			for( let i=0; i<this.peopleData.length; i++ ){
				if ( this.peopleData[i].phone.length != 11  ){
					this.$message({
						message: '请检查报名人手机号是否正确',
						type: 'warning'
					});
					ready_data = false
					return
				}
			}

			if ( !this.contactData.smscode || this.contactData.smscode.length != 6  ){
				this.$message({
					message: '请正确填写您收到的短信验证码',
					type: 'warning'
				});
				ready_data = false
				return
			}
			

			if ( ready_data == true ){

				if( this.switch_room == 'y' ){
					for( let i=0; i<this.peopleData.length; i++ ){
						if ( this.peopleData[i].spell_room == '1' && this.peopleData[i].roommate_type == '1' ){
							this.peopleData[i].end_change_room = "";
						}

						if ( this.peopleData[i].spell_room == '1' && this.peopleData[i].roommate_type == '2' ){
							this.peopleData[i].roommate_name = "";
							this.peopleData[i].roommate_phone = "";
						}
					}
				}

				let me = this;
				let post={
					u_type:'new_sms',
					url_id:this.topics_uuid,
					people:JSON.stringify(this.peopleData),
					contact:JSON.stringify(this.contactData),
					remark:this.remark,
					edit_data_uuid:this.edit_data_uuid
				}
				SBD.setPostSingupData(post).then(res => {

					if ( res.status == 'error_input' ){
						this.$message({
							message: '提交的数据不完整',
							type: 'warning'
						});
						return
					}


					if ( res.status == 'error_url' ){
						this.$message({
							message: '系统错误，请稍后再试',
							type: 'warning'
						});
						return
					}

					if ( res.status == 'wrong_sms' ){
						this.$message({
							message: '错误的短信验证码，请核对',
							type: 'warning'
						});
						return
					}

					if( res.status == 'add_ok' ){
						me.$message({
							type: 'success',
							message: '信息填报成功!'
						});
						me.edit_data_uuid = res.data_uuid
					}

					if( res.status == 'edit_ok' ){
						me.$message({
							type: 'success',
							message: '信息修改成功!'
						});
						me.edit_data_uuid = res.data_uuid
					}

					me.finishPost = true;
				})
			}

			
		},
		initData(){
			let me = this;

			if( this.topics_uuid == 'elGcMDYh' ){
				this.topics_uuid = 'eIGcMDYh';
			}

			let post={
				url_id:this.topics_uuid,
			}
			SBD.showSingUpData(post).then(res => {
				if ( res == 'error_url' ){
					this.topics_status = 'error_url';
					return
				}
				me.topicsFiles = res.topics_files;
				me.topics_status = res.topics_status;
				me.date_tips = res.date_tips;
				me.singup_title = res.title;
				me.singup_inc = res.inc;
				me.start_date = res.start_date;
				me.end_date = res.end_date;
				me.switch_room = res.switch_room;
				me.is_self_edit = res.is_self_edit;
				me.topics_singup_type = res.topics_singup_type;
			})
		},
	}
}
</script>

<style scoped>
.clear{ clear: both; }
.page_bottom{ height: 100px; }
.checked_row{ margin-bottom: 25px; }
.panel_end_change_room{ background-color: #fffdeb; margin: 10px 0 10px 0; padding: 15px; border-radius: 10px; }
.spell_detail{ background-color: #f2ffef; padding-top: 20px; border-radius: 8px; box-shadow: 2px 2px 4px #68e6bc; }
.ixx_row{ margin-bottom: 12px; }


@media only screen and (max-width: 899px) {

	#show_doc{
		width: 100%;
		height: 500px;
		border: none;
	}

	.in_body_files{  border-radius:8px; margin-top:10px; background-color: #D2E4FF; padding:10px; opacity: 0.94;  }
	.in_body_files_row{ margin-bottom: 10px; text-overflow: ellipsis; word-break: keep-all; display: inline; cursor: pointer; text-shadow: 1px 2px 3px #d7ffff; overflow: hidden; float:left; font-size: 3.4vw; margin-right:3%; width: 92%; background:url('@/assets/icon_files.png') no-repeat #EBF3FF; background-size: 15px; background-position: 2% 50%; padding: 3% 1% 3% 7%; border-radius: 6px; box-shadow: 1px 1px 3px #9ed1f1; color: #196599;  }
	

	.panel_body_ss{ padding: 0 20px 0 20px; }
	.in_body_topbar{ margin:30px 0 0 0 }
	.btn_get_edit{ position: fixed; z-index: 1; right:0; background: linear-gradient(to left bottom, #72f88f, #39c98b);  top: 200px; width: 20px; height: 65px; cursor: pointer; text-shadow: 1px 2px 1px #0d7b75; font-size: 3vw; border-bottom-left-radius:9px; border-top-left-radius:9px; box-shadow: 0 2px 3px #0e4561; padding:6px; background-color: #0d7fb8; color: #ffffff; text-align: center; }
	.btn_get_edit_row{  background: linear-gradient(to left bottom, #72f88f, #39c98b);  cursor: pointer; text-shadow: 1px 2px 1px #0d7b75; font-size: 3.4vw; border-radius: 9px; box-shadow: 0 2px 3px #0e4561; padding:10px; float: right; background-color: #0d7fb8; color: #ffffff; text-align: center; }
	

	/* .btn_get_edit{ float: right; background: linear-gradient(to bottom right, #68e6bc, #c6ffe6);  font-size: 3vw; border-radius: 7px; box-shadow: 1px 2px 4px #0e4561; padding: 8px 25px 8px 25px; color: #357c87; text-align: center; } */
	.btn_sendcode{ padding:12px 0 12px 0; text-align: center; margin-top: 22px; cursor: pointer; font-size: 3vw; width: 100%; text-align: center; }
	.checked_row_label{ margin-bottom: 5px; font-size: 3vw; }
	.soq_sss{ margin-bottom: 18px; font-size: 3.5vw; }
	.soq_sss strong{ color: #ff693f; }
	.date_tips_panel{ background: #faffea; color: #5ea997; font-size: 3vw; padding: 10px; margin-top:15px; border-radius: 6px; }
	.btn_save_all{ width: 100%; padding:15px 0 15px 0; text-align: center; font-size: 5vw; color: #ffffff; font-weight: bolder; background: linear-gradient(to bottom, #92e48b, #13af18); box-shadow: 1px 2px 4px #113d72; border-radius: 10px; margin-top: 20px; }
	.pcpk{font-size: 3.6vw; color: #1c4981; margin-top: 15px; }
	.pcpk strong{ color: #0d7fb8; }
	.in_body_topics_title{ text-align: center; color: #ffffff; font-size: 5vw; font-weight: 800; padding:10%  6% 4% 6%; text-shadow: 2px 3px 4px #1c4981; }
	.bigpage{  background: linear-gradient(to bottom right, #5099f4, #ab7bfe); }
	.in_body{ padding: 5%; border-radius: 8px; width: 90%; margin:0 auto; }
	.in_body_inc{  border-radius: 8px; color: #f7fbff; font-size: 4vw; margin: 0 0 30px 0; text-shadow: 1px 2px 4px #1c4981; }
	.in_body_date{ font-size: 4vw; text-shadow: 1px 1px 2px #f1e8ff; color: #3e0588; padding: 7px; text-align: center; background-color: #f8f4ff; opacity: 0.6; border-radius: 8px; }
	.in_body_panel{ box-shadow: 1px 3px 4px #1c4981; border-radius: 8px; background-color:#f7fbff; padding: 1% 4% 4% 4%; margin-top: 20px; position: relative; }
	.in_body_null{  background-color:#f7fbff; padding: 80px 0 80px 0;border-radius: 8px; text-align: center; }
	.btnrow_adduser{  text-align: center; font-size: 4vw; border-radius: 9px;  background: linear-gradient(to bottom right, #fff39b, #eee4ff); color: #bf661d; font-weight: bolder; padding: 7px 0 7px 0; margin-top: 17px; box-shadow: 0 0 5px #3f7e7d; }
	.red_dot{ color: #ff693f; font-size: 5vw; }
	.btn_del{ color: #d85632; font-size: 5vw; font-weight: bolder; cursor: pointer; position: absolute; right: 12px; top: 12px; }
	.btn_edit_data{ float: right; margin: 20px 0 0 0; text-align: center; font-size: 4vw; border-radius: 9px; background-color:#0e5dbe; color: #ffffff; padding: 7px 20px 7px 20px; box-shadow: 0 0 5px #92d3ed; cursor: pointer;  }
	.finish_page{ background-color: #ffffff; border-radius: 10px; padding: 20px; }
	.info_panel_remark{ border: 2px solid #5099f4; padding: 20px; margin-bottom: 20px;  border-radius: 10px; }
	.info_panel_contact{ border: 2px solid #5099f4; padding: 20px; margin-bottom: 20px;  border-radius: 10px; }
	.info_panel_people{ border: 2px solid #5099f4; margin-bottom: 20px; border-radius: 10px; padding: 20px;}
	.finish_page_title{ font-size: 6vw; font-weight: bolder; text-align: center; padding: 20px 0 10px 0; color: #13af18; }
	.finish_page_sub_title{ font-size: 4vw; color: #787878; margin: 10px 0 20px 0; }
}


/* big */
@media only screen and (min-width: 900px) {

	#show_doc{
		width: 100%;
		height: 650px;
		border: none;
	}

	.in_body_files{  border-radius:8px; margin-top:10px; background-color: #D2E4FF; padding:10px; opacity: 0.94;  }
	.in_body_files_row{ margin-bottom: 10px; text-overflow: ellipsis; word-break: keep-all; display: inline; cursor: pointer; text-shadow: 1px 2px 3px #d7ffff; overflow: hidden; float:left; font-size: 16px; margin-right:2%; width: 45%; background:url('@/assets/icon_files.png') no-repeat #EBF3FF; background-size: 15px; background-position: 2% 50%; padding: 1% 1% 1% 3%; border-radius: 6px; box-shadow: 1px 1px 3px #9ed1f1; color: #196599;  }
	.in_body_files_row:nth-child(2n){ margin-right: 0; }

	.fplx_row{ margin-top:30px; }
	.in_body_null{  background-color:#f7fbff; padding: 80px 0 80px 0;  border-radius: 8px; text-align: center; }
	.btn_get_edit{ position: fixed; right:0; z-index: 1; background: linear-gradient(to left bottom, #72f88f, #39c98b);  top: 200px; width: 30px; height: 40px; cursor: pointer; text-shadow: 1px 2px 1px #0d7b75; font-size: 14px; border-bottom-left-radius:9px; border-top-left-radius:9px; box-shadow: 0 2px 3px #0e4561; padding:10px; background-color: #0d7fb8; color: #ffffff; text-align: center; }
	.btn_get_edit_row{  background: linear-gradient(to left bottom, #72f88f, #39c98b);  width: 200px; cursor: pointer; text-shadow: 1px 2px 1px #0d7b75; font-size: 15px; border-radius: 9px; box-shadow: 0 2px 3px #0e4561; padding:8px 15px 8px 15px; background-color: #0d7fb8; color: #ffffff; text-align: center; float: right; }
	
	.panel_body_ss{ padding:10px 30% 10px 30%; }
	.in_body_topbar{ margin:30px 0 0 0 }
	/* .btn_get_edit{ cursor: pointer; float: right; background: linear-gradient(to bottom right, #68e6bc, #c6ffe6);  font-size: 14px; border-radius: 7px; box-shadow: 0 2px 3px #0e4561; padding: 8px 25px 8px 25px; color: #357c87; text-align: center; } */
	.verify_class{ width: 40%; }
	.btn_sendcode{ margin-top:24px; cursor: pointer; font-size: 14px;  width: 100%; text-align: center; }
	.in_body_date{ font-size: 16px; text-shadow: 1px 1px 2px #f1e8ff; color: #3e0588; padding: 7px; text-align: center; background-color: #f8f4ff; opacity: 0.6; border-radius: 8px; }
	
	.checked_row_label{ margin-bottom: 5px; font-size: 15px; }
	.soq_sss{  margin-bottom: 18px;  font-size: 15px; }
	.soq_sss strong{ color: #ff693f; }
	.date_tips_panel{ background: #faffea; color: #5ea997; font-size: 15px; padding: 10px; margin-top:15px; border-radius: 6px; }
	body{ max-width: 800px; }
	.btn_save_all{ width: 100%; padding:15px 0 15px 0; text-align: center; font-size: 20px; color: #ffffff; font-weight: bolder; background: linear-gradient(to bottom, #92e48b, #13af18); box-shadow: 1px 2px 4px #113d72; border-radius: 10px; margin-top: 20px; cursor: pointer;}
	.pcpk{font-size: 14px; color: #1c4981; margin-top: 15px; font-size:16px; }
	.pcpk strong{ color: #0d7b75; }
	.in_body_topics_title{ text-align: center; color: #ffffff; font-size: 27px; font-weight: 800; padding:3%  6% 0 6%; text-shadow: 2px 3px 4px #1c4981; }
	.bigpage{  background: linear-gradient(to bottom right, #5099f4, #ab7bfe); }
	.in_body{ padding:2%; border-radius: 8px; width: 900px; margin:0 auto; }
	.in_body_inc{  border-radius: 8px; color: #f7fbff; font-size: 16px; line-height: 22px; margin: 0 0 30px 0; text-shadow: 1px 2px 4px #1c4981; }
	.in_body_panel{ box-shadow: 1px 3px 4px #1c4981; border-radius: 8px; background-color:#f7fbff; padding: 1% 4% 4% 4%; margin-top: 20px; position: relative;}
	.btnrow_adduser{  text-align: center; font-size: 16px; border-radius: 9px;  background: linear-gradient(to bottom right, #fff39b, #eee4ff); color: #bf661d; font-weight: bolder; padding: 12px 0 12px 0; margin-top: 17px; box-shadow: 0 0 5px #3f7e7d; }
	.red_dot{ color: #ff693f; font-size: 13px; }
	.btn_del{ color: #d85632; font-size: 18px; font-weight: bolder; cursor: pointer; position: absolute; right: 15px; top: 15px; }
	.btn_edit_data{ float: right; margin: 20px 0 0 0; text-align: center; font-size: 16px; border-radius: 9px; background-color:#0e5dbe; color: #ffffff; padding: 7px 20px 7px 20px; box-shadow: 0 0 5px #92d3ed; cursor: pointer;  }
	.finish_page{ background-color: #ffffff; border-radius: 10px; padding: 20px; }
	.info_panel_remark{ border: 2px solid #5099f4; padding: 20px; margin-bottom: 20px;  border-radius: 10px; }
	.info_panel_contact{ border: 2px solid #5099f4; padding: 20px; margin-bottom: 20px;  border-radius: 10px; }
	.info_panel_people{ border: 2px solid #5099f4; margin-bottom: 20px; border-radius: 10px; padding: 20px;}
	.finish_page_title{ font-size: 24px; font-weight: bolder; text-align: center; padding: 20px 0 10px 0; color: #13af18; }
	.finish_page_sub_title{ font-size: 18px; color: #787878; margin: 10px 0 20px 0; }
}

</style>
